import './Footer.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import WhiteLogo from '../../assets/img/Newsily logo-white.png';


const Footer = () => {
    return ( 
        <div className="footer d-flex align-items-end justify-content-center container-fluid bg-dark">
            <div className="row mx-5 py-3">
                <div className="footer-logo col-sm-12 col-md-4 col-lg-4 my-3 d-flex justify-content-center align-items-start">
                    <img src= { WhiteLogo } alt="white-logo" />
                </div>

                <div className="footer col-sm-12 col-md-6 col-lg-4 text-white my-3 d-flex justify-content-center align-items-start">
                    <p>
                    Newsily is your one-stop location to access all the news from your favorite trusted brands frictionless and at an affordable price
                    </p>
                </div>

                <div className="footer col-sm-12 col-md-2 col-lg-4 my-3 d-flex  align-items-center flex-column text-center justify-content-start">
                        <a href="#">About</a>
                        <a href="#">Contact</a>
                </div>
            </div>
        </div>
     );
}
 
export default Footer;
